import {Component, OnInit, Optional} from '@angular/core';
import {TableHeaderService} from '../../services/table-header.service';
import {LoaderService} from '../../services/loader.service';
import {ProjectService} from '../../services/project.service';
import {ITableHeader} from '../../../interfaces/table-header';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {TableEntityExtension} from "../../extensions/table-entity-extension/table-entity.extension";
import {Subscription} from "rxjs";
import {FormService} from "../../services/form.service";
import {TableEntityExtensionService} from "../../extensions/table-entity-extension/table-entity-extension.service";
import {ActivatedRoute} from "@angular/router";
import {CardService} from "../../components/card/card.service";
import {GuardService} from '../../services/guard.service';
import {MimeTypeConfig} from "../../../configs/mime-type.config";


@Component({
  selector: 'table-project',
  templateUrl: './table-project.component.html',
  providers: [LoaderService]
})
export class TableProjectComponent extends TableEntityExtension implements OnInit {

  headers: ITableHeader[];

  query: any = {
    filters: {},
   order: null,
    relations: [
      'storeCollections',
      'product',
      'store'
    ]
  };
  collapsePreloader: boolean = false;
  acceptedFiles: string = MimeTypeConfig.zip;
  acceptedCovers: string = MimeTypeConfig.image;
  forms: any = {};
  subscriptions: Subscription[] = [];

  constructor(public loaderService: LoaderService,
              protected route: ActivatedRoute,
              protected modelService: ProjectService,
              protected tableEntityExtensionService: TableEntityExtensionService,
              @Optional() protected cardService: CardService,
              private formService: FormService,
              private tableHeaderService: TableHeaderService,
              private guardService: GuardService) {
    super(
      modelService,
      cardService,
      loaderService,
      tableEntityExtensionService,
      route
    );
  }

  ngOnInit(): void {
    this.headers = [
      this.tableHeaderService.id(),
      this.tableHeaderService.name(),
      this.tableHeaderService.store(),
      this.tableHeaderService.active(),
      this.tableHeaderService.free(),
      this.tableHeaderService.availableForDownloading(),
      this.tableHeaderService.product({filter: {
          storeQuery: (this.query.filters.store || this.query.filters.parentStore) ? {
            parentStore: this.query.filters.store || this.query.filters.parentStore
          } : null
        }}),
      this.tableHeaderService.createdAt(),
    ];
    this.checkChanges();
    this.routesInit('projects')
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    this.subscriptions.forEach(item => item.unsubscribe());
  }

  async initForm(itemCollapse: any) {
    const skipChanges = await this.guardService.skipChanges();

    if (!skipChanges || itemCollapse.result) return;


    const item = this.source[itemCollapse.position];
    this.collapsePreloader = true;
    const form = this.forms[item.id] = new FormBuilder().group({
      name: [null, Validators.required],
      product: [],
      active: [],
      free: [],
      availableForDownloading: [],
      legacy: [],
    });

    const assetsForm = {
      assets: new FormControl(),
      covers: new FormControl()
    };

    this.subscriptions.push(
      form.get('legacy').valueChanges.subscribe((result) => {
        this.formService.toggleControls(form, assetsForm, result === true, item);
      })
    );

    this.subscriptions.push(
      form.get('free').valueChanges.subscribe((result) => {
        if (result) {
          form.get('availableForDownloading').setValue(true);
          form.get('availableForDownloading').disable();
        } else {
          form.get('availableForDownloading').enable();
        }
      })
    );

    (form.get('availableForDownloading') as FormControl).registerOnDisabledChange((isDisabled) => {
      if (isDisabled) return;

      if (form.get('free').value)
        form.get('availableForDownloading').disable();
    });

    let data = await this.modelService.asyncGet({
      id: item.id,
      relations: ['assets', 'covers', 'product', 'store']
    });
    form.patchValue(data);

    this.collapsePreloader = false;
    this.formService.setDefaultValues(form);
    this.formService.setActiveForms([form]);

    itemCollapse.next();
  }


  async cancel(collapse) {
    const skipChanges = await this.guardService.skipChanges();
    if (skipChanges) this.formService.setForceSkipCheck()
    if (!skipChanges || collapse.result) return;

    collapse.toggle();
  }
}
